/*
export function head(arrayLike) {
  return arrayLike.length > 0 ? arrayLike[0] : undefined;
}
*/
export function helper_array_ofLength(n) {
    return Array.from(Array(n).keys()); // 10 => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
}
